<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="toc_h"><span class="right_1" epub:type="pagebreak" id="page_ix" title="ix">CONTENTS</span></p>
<p class="toc_fm" id="rsec1"><a href="#/text/Acknowledgments#sec1">Acknowledgments</a></p>
<p class="toc_fm" id="rsec2"><a href="#/text/Note#sec2">Note on Translations and Citations</a></p>
<p class="toc_ct1" id="rsec3"><a href="#/text/Introduction#sec3">Introduction</a></p>
<p class="toc_h1" id="rsec4"><a href="#/text/Introduction#sec4">I. The Nature of Platonic Writing</a></p>
<p class="toc_h1" id="rsec5"><a href="#/text/Introduction#sec5">II. The Method of This Work</a></p>
<p class="toc_h1" id="rsec6"><a href="#/text/Introduction#sec6">III. The Argument</a></p>
<p class="toc_pt" id="rsec7"><span href="#/text/Part01#sec7" title="Link target outside of Sample">A. Politics, Money, and Persuasion</span></p>
<p class="toc_ct" id="rsec8"><span href="#/text/Chapter01#sec8" title="Link target outside of Sample">1<span class="space">The Problem of Abstraction</span></span></p>
<p class="toc_h1" id="rsec9"><span href="#/text/Chapter01#sec9" title="Link target outside of Sample">I. The <i>Polis</i> and the Problem of the Guardians</span></p>
<p class="toc_h1" id="rsec10"><span href="#/text/Chapter01#sec10" title="Link target outside of Sample">II. Expertise and Writing</span></p>
<p class="toc_h1" id="rsec11"><span href="#/text/Chapter01#sec11" title="Link target outside of Sample">III. Money</span></p>
<p class="toc_h1" id="rsec12"><span href="#/text/Chapter01#sec12" title="Link target outside of Sample">IV. <i>Technē</i>, Money, and the Commercial <i>Polis</i></span></p>
<p class="toc_ctt" id="rsec13"><span href="#/text/Chapter02#sec13" title="Link target outside of Sample">2<span class="space">The Currencies of Power</span></span></p>
<p class="toc_h1" id="rsec14"><span href="#/text/Chapter02#sec14" title="Link target outside of Sample">I. Timocracy</span></p>
<p class="toc_h1" id="rsec15"><span href="#/text/Chapter02#sec15" title="Link target outside of Sample">II. Oligarchy</span></p>
<p class="toc_h1" id="rsec16"><span href="#/text/Chapter02#sec16" title="Link target outside of Sample">III. Democracy</span></p>
<p class="toc_pt" id="rsec17"><span class="right_1" epub:type="pagebreak" id="page_x" title="x"><span href="#/text/Part02#sec17" title="Link target outside of Sample">B. The Vicissitudes of Opinion</span></span></p>
<p class="toc_ct" id="rsec18"><span href="#/text/Chapter03#sec18" title="Link target outside of Sample">3<span class="space">True Opinion</span></span></p>
<p class="toc_h1" id="rsec19"><span href="#/text/Chapter03#sec19" title="Link target outside of Sample">I. Socrates and the New Intellectuals</span></p>
<p class="toc_h1" id="rsec20"><span href="#/text/Chapter03#sec20" title="Link target outside of Sample">II. Knowledge and the “Divided Line”</span></p>
<p class="toc_h1" id="rsec21"><span href="#/text/Chapter03#sec21" title="Link target outside of Sample">III. Sophistry</span></p>
<p class="toc_ctt" id="rsec22"><span href="#/text/Chapter04#sec22" title="Link target outside of Sample">4<span class="space">Persuasion</span></span></p>
<p class="toc_h1" id="rsec23"><span href="#/text/Chapter04#sec23" title="Link target outside of Sample">I. Persuasion</span></p>
<p class="toc_h1" id="rsec24"><span href="#/text/Chapter04#sec24" title="Link target outside of Sample">II. Virtue</span></p>
<p class="toc_h1" id="rsec25"><span href="#/text/Chapter04#sec25" title="Link target outside of Sample">III. Corruption</span></p>
<p class="toc_bm" id="rsec26"><span href="#/text/Conclusion#sec26" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc_fm" id="rsec27"><span href="#/text/Bibliography#sec27" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc_fm" id="rsec28"><span href="#/text/Index_of_Subjects#sec28" title="Link target outside of Sample">Index of Subjects</span></p>
<p class="toc_fm" id="rsec29"><span href="#/text/Index_of_Passages#sec29" title="Link target outside of Sample">Index of Passages</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0dfb17ab